import axios from 'axios';

import { KanzhongBackend } from 'constant/KanzhongBackend';
import { ServerError, createApiError } from 'stores/ApiClientError';
import { NoticeType } from 'stores/NoticeAdminStoreAdapter';

// --- 型定義 ---

export type ListUserNoticeParams = {
  isResolved: boolean;
  noticeType?: NoticeType;
};

export type DeleteUserNoticeParams = {
  noticeId: string;
};

export type ResolveUserNoticeParams = {
  noticeId: string;
};

export type UserNoticeResult = {
  noticeId: string;
  securityCheckResultId?: string;
  title: string;
  content: string;
  externalLink?: string;
  internalLink?: string;
  deadline?: string;
  priority: number;
  isNew: boolean;
  isResolved: boolean;
  createdAt: string;
};

export type UserNoticeGroupResult = {
  noticeType: NoticeType;
  needsAttention: boolean;
  notices: UserNoticeResult[];
};

// --- API関数 ---

/**
 * 通知一覧取得（ユーザー）API
 * @param params.isResolved - 解決状態（必須, true: 解決済み, false: 未解決）
 * @param params.noticeType - 通知種別（任意, "NOTICE" | "INFO" | "IMPORTANT"）
 */
export const listUserNotice = async (
  params: ListUserNoticeParams,
): Promise<UserNoticeGroupResult[]> => {
  const sessionId = localStorage.getItem('session-id');

  try {
    const response = await axios.post(KanzhongBackend.LIST_USER_NOTICE, params, {
      headers: {
        'X-Session-Id': sessionId,
      },
    });

    return response.data.results;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const { status, data } = error.response;
      throw createApiError(status, data?.message || error.message);
    }
    throw new ServerError();
  }
};

/**
 * 通知削除（ユーザー）API
 * @param params.noticeId - 通知ID（必須, 最大300文字）
 */
export const deleteUserNotice = async (params: DeleteUserNoticeParams): Promise<void> => {
  const sessionId = localStorage.getItem('session-id');

  try {
    await axios.post(KanzhongBackend.DELETE_USER_NOTICE, params, {
      headers: {
        'X-Session-Id': sessionId,
      },
    });
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const { status, data } = error.response;
      throw createApiError(status, data?.message || error.message);
    }
    throw new ServerError();
  }
};

/**
 * 通知解決（ユーザー）API
 * @param params.noticeId - 通知ID（必須, 最大300文字）
 */
export const resolveUserNotice = async (params: ResolveUserNoticeParams): Promise<void> => {
  const sessionId = localStorage.getItem('session-id');

  try {
    await axios.post(KanzhongBackend.RESOLVE_USER_NOTICE, params, {
      headers: {
        'X-Session-Id': sessionId,
      },
    });
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const { status, data } = error.response;
      throw createApiError(status, data?.message || error.message);
    }
    throw new ServerError();
  }
};
